import type { AppLocale } from './i18n';

/** Canonical BCP 47 locale used by browser speech APIs and server audio providers. */
export function speechLocaleTag(locale: AppLocale): 'fa-IR' | 'ar-SA' | 'en-US' {
  if (locale === 'fa') return 'fa-IR';
  if (locale === 'ar') return 'ar-SA';
  return 'en-US';
}
